export interface SentryEnv {
    deployment_type?: string;
    sentry_localhost_enabled?: boolean | string;
}

/**
 * Sentry reports from every deployment type except localhost, where a
 * developer has to opt in through SENTRY_LOCALHOST_ENABLED in .env. The flag
 * is baked into core.min.js as a boolean by the gulp core build.
 */
export function isSentryEnabled(env: SentryEnv): boolean {
    if (env.deployment_type !== "localhost") {
        return true;
    }
    return env.sentry_localhost_enabled === true;
}
